<template>
  <div>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <span style="color: #53b6db; padding: 20px">
      <span class="fas fa-search fa-10x"></span>
      <p>&nbsp;</p>
      <i class="fas fa-question fa-10x"></i>
      <p>&nbsp;</p>
      <i class="fas fa-handshake fa-10x"></i>
      <p>&nbsp;</p>
      <i class="fas fa-check-double fa-10x"></i>
      <p>&nbsp;</p>
      <i class="fas fa-file-signature fa-10x"></i>
      <p>&nbsp;</p>
      <i class="fas fa-paint-roller fa-10x"></i>
      <p>&nbsp;</p>
      <i class="fas fa-users fa-10x"></i>
      <p>&nbsp;</p>
      <i class="fas fa-dollar-sign fa-10x"></i>
      <p>&nbsp;</p>
    </span>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
